// @flow
import type {AuthToken} from 'modules/common/services/auth-token';

/**
 * Сервис для хранения информации об аутентификации пользователя
 */
export class TokenApi {
    _authToken: AuthToken;

    /**
     * @param authToken Сервис для работы с токеном авторизации
     */
    constructor(authToken: AuthToken) {
        this._authToken = authToken;
    }

    /**
     * Авторизует пользователя и сохраняет токен на клиенте
     * @param token токен пользователя
     */
    setToken(token: string) {
        this._authToken.set(token);
    }

    /**
     * Удаляет токен пользователя, который хранится на клиенте
     */
    logOut() {
        this._authToken.remove();
    }

    /**
     * Возвращает токен пользователя, который хранится на клиенте
     * @returns Токен
     */
    getToken() {
        return this._authToken.get();
    }
}
